import { Nota } from '../Entity/Nota';
import { FindManyReq } from '../Entity/TypeormTypes';
import { ReqGetPdfDanfeEdCliente } from '../types/EdClienteTypes';
import { ParamsGetNota } from '../types/NotaTypes';
import api from './apiEdCliente';

const PREFIX = 'api';
const ROUTE = 'edcliente/nota';

class ApiNota {
  async getOne(params: FindManyReq<Nota>) {
    const nota = await this.getMany({ ...params, take: 1 });
    return nota[0] as Nota | undefined;
  }

  async getMany(query: FindManyReq<Nota>) {
    try {
      const res = await api.post<Nota[]>(`/${PREFIX}/${ROUTE}/get`, { query });
      const data = res.data;

      return data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async count(query: FindManyReq<Nota>) {
    try {
      const res = await api.post<number>(`/${PREFIX}/${ROUTE}/count`, { query });
      const data = res.data;
      return data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }

  async getPdfDanfeNfeEdCliente(params: ReqGetPdfDanfeEdCliente) {
    try {
      const res = await api.post(
        `/${PREFIX}/${ROUTE}/getPdfDanfeNfeEdCliente`,
        { params },
        {
          responseType: 'arraybuffer',
          headers: { 'Content-Type': 'application/json', Accept: 'application/pdf' },
          timeout: 0
        }
      );

      window.open('_blank');
      return res.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async verificarXmlNotaEdCliente(nota: Nota) {
    try {
      const res = await api.post<{ existe: boolean; pathXml: string }>(
        `/${PREFIX}/${ROUTE}/verificarXmlNotaEdCliente`,
        {
          nota
        }
      );
      const data = res.data;
      return data;
    } catch (error: any) {
      console.error('ERRO AO BUSCAR NOTAS:', error);
      throw error;
    }
  }

  async gerarDanfeEdCliente(params: ParamsGetNota) {
    try {
      const res = await api.post(
        `/${PREFIX}/${ROUTE}/gerarDanfeEdCliente`,
        { params },
        { responseType: 'blob' }
      );

      return res.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}

const apiNota = new ApiNota();
export default apiNota;
